import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccTeamMentor } from '@interfaces';


export function getColumns(util: UtilityService) {
	const columns: GridColumn<AccTeamMentor, unknown>[] = [
		buildColumn(util, 'Id', row => row.accMentorId),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Last Updated' }),
		buildColumn(util, 'YesNo', row => !!row.dropout, { header: 'Dropped Out' }),
		buildColumn(util, 'Number', row => row.dropout?.dropoutWeek, { header: 'Drop-out Week' }),
	];

	return columns;

}
